module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "footer",
      "data-speed": "4",
      "data-type": "background"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('clearfix', {
    attrs: {
      "wide": true,
      "bootstrap": true
    }
  }), _vm._v(" "), _c('footer-menu'), _vm._v(" "), _c('footer-badge'), _vm._v(" "), _c('footer-copyleft'), _vm._v(" "), _c('footer-contact'), _vm._v(" "), _c('clearfix', {
    attrs: {
      "wide": true,
      "bootstrap": true
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c174e6b4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/Footer.vue
// module id = 1852
// module chunks = 1